export class FlowerLoadError extends Error {
    reason = 'bundle-load-failed';
    constructor(message, cause) {
        super(message, cause === undefined ? undefined : { cause });
        this.name = 'FlowerLoadError';
    }
}
const DEFAULT_TIMEOUT_MS = 15_000;
let loading = null;
export function loadFlowerSdk(opts) {
    loading ??= load(opts);
    return loading;
}
/** 이 페이지에서 번들을 넣었는가 — 디버그 표면과 하네스가 읽는다(넣은 뒤의 BLOOM 은 바뀐 XHR 위에서 돈다) */
export function flowerSdkRequested() {
    return loading !== null;
}
async function load({ src, deviceId, timeoutMs = DEFAULT_TIMEOUT_MS, }) {
    const w = window;
    if (w.FlowerChannel === undefined || w.FlowerSdk === undefined) {
        await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            const timer = window.setTimeout(() => {
                reject(new FlowerLoadError(`번들이 ${String(timeoutMs)}ms 안에 오지 않았다: ${src}`));
            }, timeoutMs);
            script.addEventListener('load', () => {
                window.clearTimeout(timer);
                resolve();
            });
            script.addEventListener('error', (e) => {
                window.clearTimeout(timer);
                reject(new FlowerLoadError(`번들을 받지 못했다: ${src}`, e));
            });
            document.head.appendChild(script);
        });
    }
    const FlowerChannel = w.FlowerChannel;
    const FlowerSdk = w.FlowerSdk;
    const FlowerAdView = w.FlowerAdView;
    if (FlowerChannel === undefined || FlowerSdk === undefined || FlowerAdView === undefined) {
        throw new FlowerLoadError(`번들이 window.FlowerChannel 을 내지 않았다(index.html 이 대신 왔는가): ${src}`);
    }
    try {
        FlowerSdk.setEnv('prod');
        FlowerSdk.init({ googlePal: false, fingerprint: false });
        FlowerSdk.setDeviceId(deviceId);
    }
    catch (e) {
        throw new FlowerLoadError('Flower SDK 초기화가 실패했다', e);
    }
    return { FlowerChannel, FlowerSdk, FlowerAdView };
}
//# sourceMappingURL=load-flower-sdk.js.map